import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/inventory-dashboard";

// Thunks below accept an optional query string (e.g. "locationId=..&from=..&to=..")
// so the dashboard's Location / Date filters flow through to the server.
export const fetchInventorySummary = createAsyncThunk(
  "inventoryDashboard/fetchSummary",
  async (qs: string = ""): Promise<any> => {
    const response = await axios.get(`${BASE}/summary${qs ? `?${qs}` : ""}`);
    return response.data;
  }
);

export const fetchStockByLocation = createAsyncThunk(
  "inventoryDashboard/fetchByLocation",
  async (): Promise<any> => {
    const response = await axios.get(`${BASE}/by-location`);
    return response.data;
  }
);

export const fetchLowStockItems = createAsyncThunk(
  "inventoryDashboard/fetchLowStock",
  async (qs: string = "limit=10"): Promise<any> => {
    const response = await axios.get(`${BASE}/low-stock?${qs}`);
    return response.data;
  }
);

export const fetchTopMovingProducts = createAsyncThunk(
  "inventoryDashboard/fetchTopProducts",
  async (qs: string = "days=30&limit=10"): Promise<any> => {
    const response = await axios.get(`${BASE}/top-products?${qs}`);
    return response.data;
  }
);

export const fetchDeadStock = createAsyncThunk(
  "inventoryDashboard/fetchDeadStock",
  async (qs: string = "days=60&limit=10"): Promise<any> => {
    const response = await axios.get(`${BASE}/dead-stock?${qs}`);
    return response.data;
  }
);

export const fetchTopStockItems = createAsyncThunk(
  "inventoryDashboard/fetchTopStockItems",
  async (qs: string = "limit=10"): Promise<any> => {
    const response = await axios.get(`${BASE}/top-stock?${qs}`);
    return response.data;
  }
);

// Not stored in the slice — each call is a one-off drill-down fetch for the
// clicked item, resolved directly by the dialog that requests it.
export const fetchItemMovementHistory = async (skuId: string, limit: number = 50): Promise<any> => {
  const response = await axios.get(`${BASE}/item-history/${skuId}?limit=${limit}`);
  return response.data;
};
